import Tooltip from '../ui-components/Tooltip'
import Icon from '../../preact-components/assets'
import KeyInsightCardContent from '@insided/deprecated-control/analytics/KeyInsightCardContent'
import { MetricsTypes } from '@insided/deprecated-control/EmailCampaigns/interfaces'
import classNames from 'classnames'

interface KeyInsightCardProps {
  title: string
  titleTooltip?: string
  comparisionTooltip?: string
  total?: number | string
  showComparisionUnavailable?: boolean
  percent?: number
  hideComparisionWithPreviousPeriod?: boolean
  isPercentage?: boolean
  isLoading: boolean
  isKeyInsightAvailable?: boolean
  keyInsightUnavailableMessage?: string
  metricsType?: MetricsTypes | null
  onCardClick?: ((activeMetric: MetricsTypes | null) => Promise<void>) | null
  isActive?: boolean
}

// eslint-disable-next-line import/prefer-default-export
export const KeyInsightCard = ({
  title,
  titleTooltip,
  percent,
  showComparisionUnavailable = false,
  comparisionTooltip,
  isLoading,
  hideComparisionWithPreviousPeriod = false,
  isKeyInsightAvailable = true,
  keyInsightUnavailableMessage,
  isPercentage = false,
  total = 0,
  metricsType = null,
  onCardClick = null,
  isActive
}: KeyInsightCardProps) => {
  return (
    <div
      className='metric-summary-wrapper'
      onClick={async () => {
        if (onCardClick) await onCardClick(metricsType)
      }}
    >
      <div className={classNames('metric-summary', { 'is-active': isActive, 'is-clickable': !!metricsType })}>
        <div className='metric-header'>
          <div className='metric-title'>{title}
            {titleTooltip && (
              <Tooltip
                position='right'
                trigger={<Icon icon='question' size={16} customClass='icon-info' />}
                customClasses='metric-help-tooltip'
                tooltipMessage={titleTooltip}
              />
            )}
          </div>
        </div>
        <KeyInsightCardContent
          percent={percent}
          showComparisonUnavailable={showComparisionUnavailable}
          comparisonTooltip={comparisionTooltip}
          isLoading={isLoading}
          hideComparisonWithPreviousPeriod={hideComparisionWithPreviousPeriod}
          isKeyInsightAvailable={isKeyInsightAvailable}
          keyInsightUnavailableMessage={keyInsightUnavailableMessage}
          isPercentage={isPercentage}
          total={total}
        />
      </div>
    </div>
  )
}
